import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const NoDataAvailable = () => {
	const { t } = useTranslation(['common']);

	return (
		<Typography
			variant="body2"
			color="textSecondary"
			sx={{
				my: 1,
			}}>
			{t('common:no-data-available-message')}
		</Typography>
	);
};
